import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    height: 27px;
    padding: 2px;
    border-radius: 31px;
    background-color: ${theme?.colour?.primary ?? "#1DBD6B"};
    font-size: 10px;
    font-weight: 400;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  `}
`;
